import { applyMiddleware, createStore, compose } from 'redux';
import { memoizeWith } from 'ramda';
import { install as installLoop } from 'redux-loop';
import getReducer from './reducer';
import getInitialState from './state';
import { glassboxMiddleware } from './middleware';
const getCacheKey = ({
  page,
  documentOid
}) => `${documentOid}-${page}`;
const store = memoizeWith(getCacheKey, props => {
  const composeEnhancers = process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const state = getInitialState(props);
  return createStore(getReducer(state), state, composeEnhancers(installLoop(), applyMiddleware(glassboxMiddleware)));
});
export default store;
export * from './state';
export * from './selectors';